import { render, staticRenderFns } from "./DetailHolidayDate.vue?vue&type=template&id=11436453&scoped=true"
import script from "./DetailHolidayDate.vue?vue&type=script&lang=js"
export * from "./DetailHolidayDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11436453",
  null
  
)

export default component.exports